<script setup lang="ts">
import { computed } from 'vue'
import { useVModel } from '@vueuse/core'

import BaseDrawer from './BaseDrawer.vue'

import type { ContestColor, FormattedContestGameReward, GameContest } from './contestGame'

const props = defineProps<{
  modelValue: boolean
  contestColor: ContestColor
  contestGame: GameContest
  contestGameRewards: FormattedContestGameReward[]
}>()

const emit = defineEmits<{
  (e: 'update:modelValue'): void
  (e: 'onSubmit'): void
}>()
const showIntroDrawer = useVModel(props, 'modelValue', emit)

const contestGameRewardsTexts = computed(() =>
  props.contestGameRewards?.map((d) => d?.value || d.name),
)
</script>

<template>
  <BaseDrawer
    v-model="showIntroDrawer"
    :btn="{
      text: contestGame.callToActionText,
      bgColor: contestColor.buttonColor,
      textColor: contestColor.buttonTextColor,
      isProcessing: false,
    }"
    :has-blur="false"
    :has-close-icon="false"
    :can-close="false"
    @on-btn-click="emit('onSubmit')"
    @update:model-value="emit('onSubmit')"
  >
    <template #title>
      <div class="relative flex items-center gap-4 overflow-x-hidden rounded-full bg-gray-100 py-4">
        <div v-for="i in 5" :key="i" class="flex animate-marquee gap-4 whitespace-nowrap text-base">
          <span v-for="text in contestGameRewardsTexts" :key="text">
            {{ text }}
          </span>
        </div>
      </div>
    </template>

    <template #description>
      <div class="block">
        <p class="mb-2 text-2xl font-bold text-gray-800">
          {{ contestGame.title }}
        </p>
        <p class="text-base text-gray-800">{{ contestGame.subtitle }}</p>
      </div>
    </template>
  </BaseDrawer>
</template>
